import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DnaChatBotIcon, DownArrowIcon } from "@/components/icons";

interface Props {
  needToFold?: boolean;
  defaultOpen?: boolean;
  children?: React.ReactNode;
  title?: string;
}

const HeadContainer: React.FC<Props> = ({
  needToFold,
  defaultOpen = true,
  children,
  title,
}) => {
  const { t } = useTranslation();
  const [isFold, setIsFold] = useState(false);
  const [foldDesc, setFoldDesc] = useState(t('components.headContainer.analyzing'));
  useEffect(() => {
    if (needToFold && !defaultOpen) {
      setIsFold(true);
    }
  }, [defaultOpen]);
  useEffect(() => {
    if (isFold) {
      setFoldDesc(t('components.headContainer.working'));
    } else {
      setFoldDesc(t('components.headContainer.analyzing'));
    }
  }, [isFold]);
  return (
    <div className="">
      <div className="flex items-center justify-between mb-3">
        <div className="inline-flex justify-start items-center gap-3 pl-2">
          <div className="flex justify-start items-center gap-2">
            <DnaChatBotIcon className="w-[32px] h-[24px]" />
            <div className="justify-start text-[#18203c] text-base font-medium  leading-tight font-['Bitter',_sans-serif] select-none">
              Aha
            </div>
          </div>
          <div className="w-[1px] bg-[#CCCCCC] h-[16px]"></div>
          <div className="justify-start text-[#79716B] text-xs font-medium  leading-none">
            {title || t('components.headContainer.defaultTitle')}
          </div>
        </div>
        <div className="inline-flex justify-start items-center gap-6">
          {needToFold && (
            <div className="flex justify-content items-center text-[#8b8d98] text-xs font-semibold  leading-normal">
              <div className="w-8 h-8 mr-2 flex items-center justify-center bg-white rounded-full shadow-[0px_0px_0px_5px_rgba(217,217,218,0.25)] border border-stone-300 cursor-pointer" >
                <div className={`${isFold ? '' : 'rotate-180'} transition-all duration-300`} onClick={() => setIsFold(!isFold)}><DownArrowIcon className="w-6 h-6" /></div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={`${isFold ? "hidden" : ""}`}>{children}</div>
    </div>
  );
};

export default HeadContainer;
